/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ConsultationAdminControllerDeleteMemoV1$Params {
  id: string;
  memoId: string;
}

export function consultationAdminControllerDeleteMemoV1(http: HttpClient, rootUrl: string, params: ConsultationAdminControllerDeleteMemoV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, consultationAdminControllerDeleteMemoV1.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('memoId', params.memoId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
    })
  );
}

consultationAdminControllerDeleteMemoV1.PATH = '/api/v1/consultations/admin/{id}/memos/{memoId}';
